module.exports = __webpack_public_path__ + "static/media/Yeongwol2.d0eb3cf1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Yeongwol2.jpeg
// module id = 584
// module chunks = 0